export const setErrorReducer = (
  state,
  { payload, meta: { operation, operationState } }
) =>
  operation === "SET" && operationState === "ERROR"
    ? { error: payload }
    : state;
